export default "__VITE_ASSET__MyyjDICU__"